import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SeoService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  setCanonical(url: string): void {
    let canonical = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = this.document.createElement('link');
      canonical.rel = 'canonical';
      this.document.head.appendChild(canonical);
    }
    canonical.href = url;
  }

  removeCanonical(): void {
    this.document.querySelector('link[rel="canonical"]')?.remove();
  }

  setRobots(content: string): void {
    let robots = this.document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = this.document.createElement('meta');
      robots.name = 'robots';
      this.document.head.appendChild(robots);
    }
    robots.content = content;
  }

  removeRobots(): void {
    this.document.querySelector('meta[name="robots"]')?.remove();
  }
}
